<template>
    <div id="menuResourcesWrapper">
        <!-- 搜索栏 -->
        <div class="search-box">
            <div>
                <!-- <Input v-model="searchValue" prefix="ios-search-outline" placeholder="请输入菜单名称"
          style="width: 208px; margin-right: 10px;" @on-enter="handleSearchClick" />
        <Button type="primary" @click="handleSearchClick">搜索</Button>-->
                <Select style="width:300px" v-model="rs_code" @on-change="selectChangeClick">
                    <Option v-for="(item, index) in selectValueOptions" :value="item.con_code + ''" :key="index">
                        {{ item.con_name }}
                    </Option>
                </Select>
            </div>
            <div>
                <Button v-if="hasPerm('resources_menu_add_btn') == 2" class="ys-confirm" icon="ios-add" @click="handleAddClick">新建</Button>
            </div>
        </div>
        <!-- 表格 -->
        <el-table
            :columns="Columns"
            :rowKey="'rs_code'"
            :tableData="tableData"
            :loading="tableLoading"
            :tableHeight="tableHeight"
            @on-btn-click="onBtnClick"
        ></el-table>
        <!-- 分页 -->
        <!-- <div class="paging-box">
      <Page :total="totalCount" @on-change="handlePagingClick" />
    </div>-->
        <!-- 弹框 -->
        <add-model
            v-if="currentMenuStatusValues"
            :currentIndex="currentIndex"
            :currentMenuStatus="currentMenuStatus"
            :titleLayer="titleLayer"
            :addObj="addObj"
            :editObj="editObj"
            @on-jurisdiction-click="onJurisdictionClick"
        ></add-model>
        <!-- 二次确认框 -->
        <Alter ref="AlterModal" :configData="AlterConfigData" @change_ok="deleteResources()"></Alter>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import elementResizeDetectorMaker from 'element-resize-detector'; // 获取元素的高度
import ElTable from '_g/commonComponent/table/elTable.vue';
import AddModel from '../components/addModes.vue';
import Columns from './tableConfig.js';
export default {
    components: {
        'el-table': ElTable,
        'add-model': AddModel,
    },
    data() {
        return {
            tableData: [], // 数据
            Columns: [], // 表头
            totalCount: 20, // 总条数
            tableHeight: 0,
            searchValue: '', // 搜索框的值
            currentIndex: 0, // 监听
            currentMenuStatus: false,
            currentMenuStatusValues: false,
            titleLayer: '新建',
            selectValueOptions: null, // 下拉框数据
            rs_code: '', // 下拉框选中的值
            addObj: null, // 新建傳遞的值
            editObj: null, // 編輯傳遞的值
            AlterConfigData: {}, //二次弹框配置数据
            delateItem: null,
            tableLoading: true, // 表格loading
        };
    },
    methods: {
        ...mapActions([
            'ConfigCodeView_qryConfigByType', // 下拉框查询
            'listSearchMenu', // 列表查询
            'deleteResource', // 删除
        ]),
        // 获取元素的高度
        getElementHeight() {
            let ERD = elementResizeDetectorMaker();
            let _this = this;
            ERD.listenTo(document.getElementById('menuResourcesWrapper'), element => {
                _this.tableHeight = element.scrollHeight - 66 - 90;
            });
        },
        // 操作按钮
        onBtnClick(rowItem, options) {
            switch (options.code) {
                case '增加':
                    this.handleAddClickProcess(rowItem);
                    break;
                case '复制':
                    this.handleCopyFather(rowItem);
                    break;
                case '编辑':
                    this.editObj = {
                        ...rowItem,
                        bl_rs_code: this.rs_code,
                    };
                    this.processing(2);
                    break;
                case '删除':
                    this.delateItem = rowItem;
                    this.AlterConfigData = {
                        type: 'warning',
                        title: '警告',
                        content: '是否确认删除当前企业信息？',
                    };
                    this.$refs.AlterModal.OpenModal();
                    // this.deleteResources(rowItem);
                    break;
                default:
                    break;
            }
        },
        // 复制功能数据处理
        handleCopyFather(options) {
            let ev = options;
            if (options.rs_level === -2 || options.rs_level === 1) {
                // 顶级
                ev = {
                    ...ev,
                    father_level: -2,
                };
            } else {
                ev = {
                    ...ev,
                    father_level: options.rs_level - 1,
                };
            }
            ev = {
                ...ev,
                bl_rs_code: this.rs_code,
            };
            this.editObj = ev;
            // this.editObj = rowItem;
            this.processing(3);
        },
        // 列表里面的新加
        handleAddClickProcess(options) {
            this.addObj = {
                ...options,
                con_name: options.fs_cn_name,
                rs_code: this.rs_code,
                super_rs_code: options.rs_code,
            };
            if (options.rs_level === -2) {
                // 顶级
                this.addObj = {
                    ...this.addObj,
                    rs_level: 1,
                };
            } else {
                this.addObj = {
                    ...this.addObj,
                    rs_level: options.rs_level + 1,
                };
            }
            this.processing(1);
        },
        // 新建功能
        handleAddClick() {
            for (let i = 0; i < this.selectValueOptions.length; i += 1) {
                if (this.selectValueOptions[i].con_code === this.rs_code) {
                    this.addObj = {
                        con_name: this.selectValueOptions[i].con_name,
                        rs_level: -2,
                        rs_code: this.selectValueOptions[i].con_code,
                        super_rs_code: this.selectValueOptions[i].con_code,
                    };
                }
            }
            if (!this.addObj) return;
            this.processing(1);
        },
        // 分页功能
        handlePagingClick(res) {},
        // 新建跟编辑封装
        processing(code) {
            this.currentIndex++;
            this.currentMenuStatus = true;
            this.currentMenuStatusValues = true;
            this.titleLayer = code;
        },
        // 回调
        onJurisdictionClick(res) {
            this.currentMenuStatus = false;
            this.currentMenuStatusValues = false;
            // 刷新页面
            res != 2 && this.listSearchMenus();
        },
        // 下拉框值的修改
        selectChangeClick(res) {
            this.rs_code = res;
            if (!this.rs_code) return;
            this.listSearchMenus();
        },
        // 处理列表数据
        handleItemOptions(options) {
            if (options && options[0].rs_level === -1) {
                if (options[0].sub_list && options[0].sub_list[0].rs_level === -1) {
                    let ev = this.recursion(options[0].sub_list[0].sub_list, 'sub_list', 'children');
                    this.tableData = ev;
                } else {
                    let ev = this.recursion(options[0].sub_list, 'sub_list', 'children');
                    this.tableData = ev;
                }
            } else {
                let ev = this.recursion(options, 'sub_list', 'children');
                this.tableData = ev;
            }
            this.tableLoading = false;
        },
        // 遞歸處理
        recursion(obj, oldField, field) {
            if (!obj) return [];
            if (typeof obj != 'object' || obj instanceof Array == false) return obj;
            let o = [];
            for (let i = 0; obj[i]; i++) {
                obj[i]['title'] = obj[i].rs_cn_name;
                o[i] = o[i] || {};
                for (let item in obj[i]) {
                    if (item != oldField) {
                        o[i][item] = obj[i][item];
                    } else {
                        o[i][field] = this.recursion(obj[i][item], oldField, field);
                    }
                }
            }
            return o;
        },
        // 下拉框查询
        async selectSearchs() {
            try {
                const data = await this.ConfigCodeView_qryConfigByType();
                if (data.request_state) {
                    this.selectValueOptions = data.config_list;
                    this.rs_code = data.config_list[0].con_code;
                    this.listSearchMenus();
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 获取列表数据
        async listSearchMenus() {
            try {
                this.tableLoading = true;
                const data = await this.listSearchMenu({
                    rs_code: this.rs_code,
                });
                if (data.request_state) {
                    this.handleItemOptions(data.infos);
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 删除数据
        async deleteResources() {
            try {
                const data = await this.deleteResource({
                    rs_code: this.delateItem.rs_code,
                });
                if (data.request_state) {
                    this.$Message.success('删除成功！');
                    // 刷新页面
                    this.listSearchMenus();
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        this.Columns = Columns;
        // 获取元素高度
        this.getElementHeight();
        // 获取下拉框资源
        this.selectSearchs();
    },
};
</script>
<style lang="less" scoped>
#menuResourcesWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
        width: 100%;
        height: 66px;
        padding: 22px 0px 12px 0px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
    }

    .paging-box {
        position: fixed;
        bottom: 0px;
        right: 50px;
        z-index: 1;
        height: 60px;
        width: calc(100% - 250);
        text-align: right;
    }
}
</style>
